import apiService from 'src/enviroment';

// eslintdisablenextline import/preferdefaultexport
const service4w = {
  get4w: (service) => apiService.get(`/segmentacion/maestros/${service}/`),
  getSelector: () => apiService.get('/segmentacion/maestros/marcaslineas/'),
  post4w: (param, service) => {
    const body = { marca: param.MARCA, linea: param.LINEA };
    return apiService.post(`/segmentacion/maestros/${service}/`, body);
  },
  delete4w: (params, service) => apiService.delete(
    `/segmentacion/maestros/${service}/?marca=${params.marca}&linea=${params.linea}&id=${params.uuid}`,
  ),
};

export default service4w;
